import React from 'react';

import Header from '../containers/Header.jsx';
import Navigator from '../containers/Navigator.jsx';
import Footer from '../containers/Footer.jsx';
import Text from '../simple_components/Text.jsx';
import Image from '../simple_components/Image.jsx';

import '../styles/Press.scss';

function Press(props){
    return(
        <>
            <Header setLanguage={props.setLanguage} {...props.header} />
            <Navigator {...props.navigator} />
            <div id={props.id} className={props.className}>
                {props.presses.map((press,index)=>(
                    <>
                        <div key={index} className={props.container_className}>
                            <Text {...press.text} />
                        </div>
                        {press.images.map((image,index)=>(<Image key={index} {...image} />))}
                    </>
                ))}
            </div>
            <Footer {...props.footer} />
        </>
    );
}

export default Press;